export const GLOBAL_ADMINISTRATOR_ROLE = "GlobalAdministrator";
export const GLOBAL_LICENSE_MANAGER_ROLE = "GlobalLicenseManager";

export const ADMIN_TOOLS_ROLE_NAMES = [GLOBAL_ADMINISTRATOR_ROLE, GLOBAL_LICENSE_MANAGER_ROLE] as const;
export const GLOBAL_ADMIN_ONLY_ROLE_NAMES = [GLOBAL_ADMINISTRATOR_ROLE] as const;

type RoleLike = string | { name?: string | null } | null | undefined;

const getRoleName = (role: RoleLike): string | null => {
  if (typeof role === "string") {
    return role;
  }

  return typeof role?.name === "string" ? role.name : null;
};

export const hasAnyRole = (roles: readonly RoleLike[], requiredRoles: readonly string[]): boolean => {
  const roleNames = new Set(roles.map(getRoleName).filter((roleName): roleName is string => roleName != null));

  return requiredRoles.some((requiredRole) => roleNames.has(requiredRole));
};
